import React from "react";
import * as Icon from "react-feather";
import { Link } from "react-router-dom";

import { H6 } from "../../atoms/Texts";

const Breadcrumb = ({ history }) => {
  return (
    <div className="flex items-center mt-2">
      {history.map((route) => (
        <Link key={route.path} to={route.path} className="flex items-center mr-2">
          <Icon.ChevronRight size={16} className="mr-1" color="#5C5C5C" />
          <H6 color="#7D7B96" fontSize="14px">
            {route.title}
          </H6>
        </Link>
      ))}
    </div>
  );
};

export default Breadcrumb;
